import _merge from 'lodash/merge';
import _set from 'lodash/set';
import Store from 'lightningjs-redux';
import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle } from './kidsLeavePopup.style';
import { Button } from '../../tornado/button/button.component';
import { t } from '../../i18n';
import { Password } from './password/password.component';
import { generatePassword } from './kidsLeavePopup.utils';
import KeyboardNumbers from '../../tornado/keyboard/keyboardNumbers/keyboardNumbers.component';
import { LETTER_SELECTED_SIGNAL } from '../../tornado/keyboard/keyboard.constants';
import { passwordCharacters, PASSWORD_LENGTH } from './kidsLeavePopup.constant';
import { HIDE_POPUP_SIGNAL } from '../../popupContainer/popupContainer.constants';
import { createItemAction } from '../../cta/cta.actions';

export class KidsLeave extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
        },
        Button: {
          type: Button,
          label: t('global.back'),
        },
        Content: {
          Title: {
            text: {
              text: t('leavingKidsSection.title'),
            },
          },
          PasswordBlock: {
            type: Password,
          },
          Exception: {
            text: {
              text: t('leavingKidsSection.wrongCode'),
            },
          },
          Keyboard: {
            type: KeyboardNumbers,
            signals: {
              [LETTER_SELECTED_SIGNAL]: '_handleSelectedLetter',
            },
          },
        },
        passSignals: {
          [HIDE_POPUP_SIGNAL]: true,
        },
      },
      getInitialStyle(),
    );
  }

  static _states() {
    return [
      class Keyboard extends this {
        _getFocused() {
          return this.tag('Keyboard');
        }
      },
      class Button extends this {
        _getFocused() {
          return this.tag('Button');
        }
      },
    ];
  }

  set payload(value) {
    this._payload = value;
  }

  get isEmptyPassword() {
    return this.password === '';
  }

  get isAllPassword() {
    return this.password.length === PASSWORD_LENGTH;
  }

  _init() {
    this.generatedPassword = generatePassword(PASSWORD_LENGTH);
    this.password = '';

    this.tag('Keyboard').renderKeyboard(passwordCharacters);
    this.tag('PasswordBlock').setPasswordText(this.generatedPassword);
    this._setState('Keyboard');
  }

  _handleSelectedLetter(letter) {
    if (this.isEmptyPassword) this._resetPasswordView();

    this._updatePassword(letter);

    if (this.isAllPassword) this._validatePassword();
  }

  _updatePassword(value) {
    this.tag('PasswordBlock').push(value);
    this.password += value;
  }

  _validatePassword() {
    if (this.generatedPassword === this.password) {
      _set(this._payload, 'item.action.target.value_layout.type', 'profilesgate');
      this.signal(HIDE_POPUP_SIGNAL);
      Store.dispatch(createItemAction(this._payload));

      return;
    }
    this.password = '';
    this._showException();
  }

  _resetPasswordView() {
    this.tag('PasswordBlock').clearPasswordInput();
    this._hideException();
  }

  _handleEnter() {
    this.signal(HIDE_POPUP_SIGNAL);

    return true;
  }

  _showException() {
    this.tag('Exception').alpha = 1;
  }

  _hideException() {
    this.tag('Exception').alpha = 0;
  }

  _handleDown() {
    this._setState('Keyboard');

    return false;
  }

  _handleUp() {
    this._setState('Button');

    return false;
  }
}
